import React, { useState, useRef } from "react";

import { Pagination, EffectFade, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTranslation } from "react-i18next";

import imgSlide01 from "../assets/img_main_slide_01.jpg";
import imgSlide02 from "../assets/img_main_slide_02.jpeg";
import imgSystem01 from "../assets/img_main_system_01.jpg";
import imgSystem02 from "../assets/img_main_system_02.jpg";
import imgSystem03 from "../assets/img_main_system_03.jpg";
import imgPoint01 from "../assets/img_main_point_01.jpg";
import imgPoint02 from "../assets/img_main_point_02.jpg";
import imgPoint03 from "../assets/img_main_point_03.jpg";

const Main = () => {
    const { t } = useTranslation();

    return (
        <main className="main-container">
            <section className="sec-visual">
                <Swiper
                    modules={[Pagination, EffectFade, Autoplay]}
                    effect="fade"
                    fadeEffect={{ crossFade: true }}
                    loop={true}
                    loopedSlides={1}
                    // autoplay={{ delay: 2500 }}
                    pagination={{ clickable: true }}
                    hyreslidesPerView={1}
                    //onSlideChange={() => console.log("slide change")}
                    //onSwiper={swiper => console.log(swiper)}
                    // breakpoints={{
                    //     500: {
                    //         slidesPerView: 2
                    //     },
                    //     1024: {
                    //         slidesPerView: 1
                    //     }
                    // }}
                >
                    <SwiperSlide>
                        <div className="img_box">
                            <img src={imgSlide01} alt="메인슬라이드01" />
                        </div>
                        <div className="text_box">
                            <h2>{t("무구속, 무자각 비대면 복지 솔루션")}</h2>
                            <h3>{t("독거노인 고독사 예방 매트리스")}</h3>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="img_box">
                            <img src={imgSlide02} alt="메인슬라이드02" />
                        </div>
                        <div className="text_box">
                            <h2>{t("무구속 무자각 방식 다중 생체신호 측정 시스템")}</h2>
                            <h3>{t("「효심」")}</h3>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </section>

            <section className="sec-information">
                <h2>{t("사용자의 건강 모니터링을 한눈에!")}</h2>
                <h3>{t("비대면 복지 솔루션, 건강 모니터링 시스템을 제공합니다.")}</h3>

                <ul className="system_list">
                    <li>
                        <div className="img_box">
                            <img src={imgSystem01} alt="시스템이미지01" />
                        </div>
                        <p className="bold">{t("센서부 시스템")}</p>
                        <p className="txt">
                            {t("심장 박동으로 혈관이 수축ㆍ팽창할 때")} <br />
                            {t("발생하는 인체의 미세 진동을 증폭하여 측정")}
                        </p>
                    </li>
                    <li>
                        <div className="img_box">
                            <img src={imgSystem02} alt="시스템이미지02" />
                        </div>
                        <p className="bold">{t("독거노인 및 환자 생체신호 측정")}</p>
                        <p className="txt">
                            {t("무구속, 무자각 방식으로 간섭없이")} <br />
                            {t("전용 매트를 통해 생체정보 측정")}
                        </p>
                    </li>
                    <li>
                        <div className="img_box">
                            <img src={imgSystem03} alt="시스템이미지03" />
                        </div>
                        <p className="bold">{t("수면 분석 및 단계 예측")}</p>
                        <p className="txt">
                            {t("측정된 생체신호로부터 심박 변이도 추출과 데이터 기반")} <br />
                            {t("학습을 통해 인공지능 (AI) 수면 분석 및 예측")}
                        </p>
                    </li>
                </ul>

                <ul className="point_list">
                    <li>
                        <h4>POINT 01</h4>
                        <div className="img_box pd">
                            <img src={imgPoint01} alt="포인트이미지01" />
                        </div>
                        <p className="txt">
                            {t("2개의 센서로 이루어진 센서부 시스템으로 심장 박동으로")}
                            <br />
                            {t("혈관이 수축ㆍ팽창할 때 발생하는 인체의 미세 진동을")}
                            <br />
                            {t("증폭하여 생체신호 측정")}
                        </p>
                        <p className="ex">
                            <span>ㆍ{t("FSR 센서 : 움직임에 대한 노이즈 (모션 아티팩트) 완화와 재실감지 기능 부여")}</span>
                            <span>ㆍ{t("Piezo 센서 : 심박수 및 호흡수 측정")}</span>
                        </p>
                    </li>
                    <li>
                        <h4>POINT 02</h4>
                        <div className="img_box">
                            <img src={imgPoint02} alt="포인트이미지02" />
                        </div>
                        <p className="txt">
                            {t("정자세 혹은 좌측, 우측 등 매트리스 위에서 다양한")} <br />
                            {t("자세에서도 실시간으로 최적의 신호를 선택하여")} <br />
                            {t("심박 및 호흡 등 생체정보 측정과 자세 감지 가능")}
                        </p>
                    </li>
                    <li>
                        <h4>POINT 03</h4>
                        <div className="img_box">
                            <img src={imgPoint03} alt="포인트이미지03" />
                        </div>
                        <p className="txt">
                            {t("측정된 생체신호로부터 심박 변이도 추출과")} <br />
                            {t("데이터 기반 학습을 통해 인공지능(AI)")} <br />
                            {t("수면 분석 및 수면 단계 예측 가능")}
                        </p>
                    </li>
                </ul>
            </section>
        </main>
    );
};

export default Main;
